import useCustomHook from '@/hooks/useCustomHook';

export default function useOptionsPage({
  page,
  options,
  multiple,
  activityActions,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      selectedOptions: [],
      answered: false,
      correct: false,
    },
    actions: {
      onChange: (optionId, value) => {
        if (multiple) {
          let selectedOptions = [...state.selectedOptions];
          const changedOption = state.selectedOptions.find(
            (o) => o.id == optionId
          );
          selectedOptions = changedOption
            ? [
                ...selectedOptions.filter((o) => o.id != optionId),
                { id: optionId, value },
              ]
            : [...selectedOptions, { id: optionId, value }];
          const answered = selectedOptions.length == options.length;
          const correct = selectedOptions.every((o) => {
            const correspondingOption = options.find(
              (option) => option.id == o.id
            );
            return isCorrect(o, correspondingOption);
          });
          if (answered) {
            const answers = selectedOptions.map((selectedOption) => {
              const correspondingOption = options.find(
                (option) => option.id == selectedOption.id
              );
              return {
                id: correspondingOption.id,
                answerId: selectedOption.id,
                correct: isCorrect(selectedOption, correspondingOption),
                pageId: page.id,
              };
            });
            actions.setState({
              answered: true,
              correct: correct,
              selectedOptions,
            });
            activityActions.onActivityProgress(page.id, answers);
          } else {
            actions.setState({ selectedOptions });
          }
        } else {
          const answer = {
            id: page.id,
            answerId: optionId,
            correct: !!options.find((o) => o.id == optionId).correct,
            pageId: page.id,
          };
          actions.setState({
            answered: true,
            correct: answer.correct,
            selectedOptions: [optionId],
          });
          activityActions.onActivityProgress(page.id, [answer]);
        }
      },
    },
  });

  return { state, actions };
}

function isCorrect(selectedOption, correspondingOption) {
  return (
    (correspondingOption.correct && selectedOption.value) ||
    (!correspondingOption.correct && !selectedOption.value)
  );
}
